<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import { nextTick } from 'vue'
import { initializeI18nLanguage } from '@/utils/i18n'

// import { getSubMessage } from '@/utils'











































































onShow(() => {
  console.log('App Show')

  // 每次显示时也同步一次语言，确保语言正确
  initializeI18nLanguage()

  // getSubMessage()



})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}
// @media screen and (min-width: 1024px) {
//   html {
//     width: 600px !important;
//     margin: 0 auto !important;
//     background: red !important;
//   }
// }
@font-face {
  font-family: 'HarmonyOS_Sans_Regular';
  font-style: normal;
  font-weight: normal;
  src: url('https://hx-mp-res.hitrips.cn/bikecat/HarmonyOS_Sans_Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'HarmonyOS_Sans_Medium';
  font-style: normal;
  font-weight: normal;
  src: url('https://hx-mp-res.hitrips.cn/bikecat/HarmonyOS_Sans_Medium.ttf') format('truetype');
}
@font-face {
  font-family: 'HarmonyOS_Sans_Bold';
  font-style: normal;
  font-weight: normal;
  src: url('https://hx-mp-res.hitrips.cn/bikecat/HarmonyOS_Sans_Bold.ttf') format('truetype');
}
page {
  font-family: 'PingFang SC', 'HarmonyOS_Sans_Regular', sans-serif;
  font-size: 30rpx;
  color: #333; /* 直接设置字体颜色 */
  background-color: #f7f7f7;
}
#app {
  font-family: 'HarmonyOS_Sans_Regular';
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.ellipsis-4 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 4 !important;
  -webkit-box-orient: vertical !important;
}

.no-scrollbar::-webkit-scrollbar {
  display: none; /* 对于Chrome, Safari和Opera */
}

.no-scrollbar {
  -ms-overflow-style: none; /* 对于IE和Edge */
  scrollbar-width: none; /* 对于Firefox */
}
:deep(.wd-calendar__range-label) {
  display: none !important;
}
</style>
